import { slot, createEventBus } from 'ts-event-bus';

export const AppEvents = {
  error: slot<string>(),
  success: slot<string>(),
  pwaUpdate: slot<ServiceWorkerRegistration>()
};

const EventBus = createEventBus({
  events: AppEvents
});

export default EventBus;
